module.exports = __webpack_public_path__ + "static/img/wealth_level_71.36f73bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_71.png
// module id = 9gWe
// module chunks = 0